import type { FC } from "react";
import { Link } from "react-router-dom";
import { Card, CardActionArea, CardHeader } from "@mui/material";
import type { UserType } from "@/types/graphql/admin";
import { UserAvatar } from "@/admin/shared/ui";
import { getUserDisplayName } from "@/admin/shared/utils";
import { PagePaths } from "@/admin/shared/constants";

export interface UserCardProps {
  user: UserType;
}

export const UserCard: FC<UserCardProps> = ({ user }) => {
  const editProfilePath = `${PagePaths.users}?tab=details&id=${user.id}`;

  return (
    // Карточка — часть полотна сайдбара, а не отдельный блок поверх него:
    // собственный фон и скругление делали её «съехавшей» между разделителями
    <Card elevation={0} sx={{ borderRadius: 0, bgcolor: "transparent" }}>
      <CardActionArea component={Link} to={editProfilePath}>
        <CardHeader
          avatar={
            <UserAvatar
              userId={user.id}
              avatarUrl={user.avatar?.url}
              size={32}
              sx={{ bgcolor: "primary.main" }}
            />
          }
          title={getUserDisplayName(user)}
          subheader={user.email}
          slotProps={{
            content: { sx: { minWidth: 0 } },
            title: { variant: "subtitle2", noWrap: true },
            subheader: { variant: "caption", noWrap: true },
          }}
          sx={{ py: 1.5, px: 2 }}
        />
      </CardActionArea>
    </Card>
  );
};
